module.exports = __webpack_public_path__ + "2a5827e987d81e6a7dc8c0b5e53e14f2.svg";